import clsx from "clsx";
import Link from "next/link";
import { FC } from "react";
import { pagesPath } from "@/lib/$path";
import { TestIdProps } from "@/test/testId/testIds";

export const ContactLink: FC<TestIdProps> = ({ testId }) => {
  return (
    <Link
      data-testid={testId}
      href={pagesPath.inquiry.$url()}
      className={clsx(
        "inline-block rounded-full border border-solid border-gray bg-primary px-[16px] py-[8px] text-[22px] text-white",
      )}
    >
      お問合せ
    </Link>
  );
};
